import { render, staticRenderFns } from "./removeDriverModal.vue?vue&type=template&id=41a1b1a9"
import script from "./removeDriverModal.vue?vue&type=script&lang=js"
export * from "./removeDriverModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports